/**
 * Groups local authorities by region with the following format:
 * [
 *  {
 *    group: "Region 1",
 *    items: [{ value: "LA1", label: "LA Label 1" }]
 *  }
 * ]
 *
 * @param {Array} localAuthorities - Array of local authority data
 * @returns {Array} - Array of local authority ids (value) and name (label) grouped by region
 */
export function mapLocalAuthoritiesGroupedByRegion(localAuthorities = []) {
  if (!localAuthorities.length) {
    return [];
  }

  const map = new Map();
  const noRegionLabel = "Unknown Region";

  for (const localAuthority of localAuthorities) {
    const region = localAuthority.region ? localAuthority.region : noRegionLabel;

    if (!map.has(region)) {
      map.set(region, []);
    }

    map.get(region).push({ value: localAuthority.id, label: localAuthority.name });
  }

  return Array.from(map.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([group, items]) => ({
      group,
      items: items.sort((x, y) => x.label.localeCompare(y.label)),
    }));
}
